/* eslint-disable no-unused-expressions */
import { useEffect } from 'react';
import BackdropWrap from './style';

const Backdrop = (props) => {
  const { show, onClickBackdrop, zIndex } = props;

  useEffect(() => {
    show && (document.body.style.overflow = 'hidden');
    !show && (document.body.style.overflow = 'unset');
  }, [show]);

  if (show) {
    return <BackdropWrap onClick={onClickBackdrop} zIndex={zIndex} />;
  }
  return <div />;
};

export default Backdrop;
